// Lib
import React from 'react';

// Utils
import { getHasClones } from '../../../common/elements/utils/elementPropertyUtils';

// Components
import CardEditor, { CardEditorProps } from './CardEditor';
import CloneCardEditor from './CloneCardEditor';

// Types

type CardEditorSwitchProps = CardEditorProps & {
    isClone: boolean;
};

const CardEditorSwitch = (props: CardEditorSwitchProps) => {
    const {
        element,
        isClone,
        isEditing,
        isEditable,
        isSingleSelected,
        isFocusedForegroundElement,
        currentEditorId,
        editorRef,
        saveContent,
        startEditing,
        moveElementsToTrash,
        createNewCard,
    } = props;

    if (getHasClones(element) || isClone) return <CloneCardEditor {...props} />;

    return (
        <CardEditor
            element={element}
            isEditing={isEditing}
            isEditable={isEditable}
            isSingleSelected={isSingleSelected}
            isFocusedForegroundElement={isFocusedForegroundElement}
            currentEditorId={currentEditorId}
            editorRef={editorRef}
            saveContent={saveContent}
            startEditing={startEditing}
            moveElementsToTrash={moveElementsToTrash}
            createNewCard={createNewCard}
        />
    );
};

export default CardEditorSwitch;
